import React from "react";
import { NavWrap } from "./ShopForTyres";
import Bulk from "./Bulk";
import { useState } from "react";
import BulkPreview from "./BulkPreview";
const CreateBulk = () => {
  const [preview, setPreview] = useState(false);
  const [table, setTable] = useState({
    rows: [],
    cols: []
  });

  return (
    <NavWrap>
      {!preview && <Bulk setPreview={setPreview} setTable={setTable} />}
      {preview && <BulkPreview table={table} setPreview={setPreview} setTable={setTable}/>}
    </NavWrap>
  );
};

export default CreateBulk;
